import React from 'react';
import SpecialInitiativesForm from './SpecialInitiativesForm';

const SpecialInitiativesEdit = (props) => (
    <SpecialInitiativesForm {...props} mode="edit" />
);

export default SpecialInitiativesEdit;
